/*
 * Copyright (c) 2020 Honeywell International Inc. All Rights Reserved.
 * Honeywell and its product names are among the trademarks and/or service marks owned by Honeywell International, Inc., or its subsidiaries.
 *
 * For patent information, see http://www.hsmpats.com.
 */

import React from 'react';
import { DataTable } from '@scuf/datatable';
import { Grid, Icon, Tooltip } from '@scuf/common';

class SiteTable extends React.Component {
  constructor(props) {
    super(props);
  }

  // Function: creates icons next to site name in the Available sites and Associated sites table
  siteAssociationAction = (site, action) => {
    let icon;
    if (action === `add`) {
      icon = (
        <>
          <a onClick={() => this.associateSite(site, action)}>
            <Tooltip
              element={<Icon name="slider-controls-plus" size="large" />}
              content="Add User To Site"
              position="top right"
            />
          </a>
        </>
      );
    } else if (site.identifier !== 'undefined' && site.identifier === -1) {
      icon = <></>;
    } else {
      icon = (
        <>
          <a onClick={() => this.associateSite(site, action)}>
            <Tooltip
              element={<Icon name="slider-controls-minus" size="large" />}
              content="Remove User From Site"
              position="top right"
            />
          </a>
        </>
      );
    }

    return <div>{icon}</div>;
  };

  // Function
  // 1. adds site to the associated list and removes it from available list
  // 2. removes site from associated list and adds to available list
  associateSite = (site, action) => {
    const { allSites } = this.props;
    let { sites } = this.props;

    if (action === 'add') {
      sites.push({ identifier: site.value, siteName: site.text });
      // remove site from available list
      const newAllSites = this.props.allSites.filter((_site) => {
        return _site != site;
      });
      this.props.setAllSites(newAllSites);

      // add site in associated list
      this.props.setSites(sites);
    } else {
      allSites.push({ value: site.identifier, text: site.siteName });
      sites = this.props.sites.filter((_site) => {
        return _site != site;
      });
      this.props.setAllSites(allSites);

      // add site in associated list
      this.props.setSites(sites);
    }
  };

  render() {
    return (
      <Grid.Row>
        <Grid.Column width={4}>
          <DataTable
            data={this.props.sites}
            resizableColumns
            columnResizeMode="fit"
            reorderableColumns={false}
            scrollable
            search={false}
            metaKeySelection={false}
          >
            <DataTable.Column field="siteName" header="Site" sortable initialWidth="25%" />
            <DataTable.Column
              field="identifier"
              header="Action"
              sortable={false}
              initialWidth="15%"
              renderer={(props) => this.siteAssociationAction(props.rowData, 'remove')}
            />
          </DataTable>
        </Grid.Column>

        <Grid.Column width={4}>
          <DataTable
            data={
              this.props.allSites === null
                ? []
                : this.props.allSites === undefined
                ? []
                : this.props.allSites
            }
            resizableColumns
            columnResizeMode="fit"
            reorderableColumns={false}
            scrollable
            search={false}
            metaKeySelection={false}
          >
            <DataTable.Column field="text" header="Site" sortable initialWidth="25%" />
            <DataTable.Column
              field="value"
              header="Action"
              sortable={false}
              initialWidth="15%"
              renderer={(props) => this.siteAssociationAction(props.rowData, 'add')}
            />
          </DataTable>
        </Grid.Column>
      </Grid.Row>
    );
  }
}

export default SiteTable;
